import { useAuthStore } from '@/stores/auth';
import { logger } from '@/utils/logger';

export async function downloadBackupCodes(otp) {
    const textToWrite = otp.otp_backup_codes.join('\n');
    const blob = new Blob([textToWrite], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'zyxel_otp_backup_codes.txt';
    link.click();

    URL.revokeObjectURL(url);
}

export async function generateNewBackupCodes() {
    const auth = useAuthStore();

    try {
        const new_backup_codes = await auth.generateOPTBackupCodes();
        return new_backup_codes;
    } catch (error) {
        logger.error("Error generating new backup codes:", error);
    }
}
